import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import portland__asset from "@/assets/restore/locations/portland.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Portland",
    address: "205 SE Spokane St, Suite 300",
    img: portland__asset.url,
    mapUrl: map("205 SE Spokane St Portland OR"),
    to: "/locations/oregon/portland/",
  },
];

export const Route = createFileRoute("/locations/oregon/")({
  head: () => ({
    meta: [
      { title: "Oregon Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Oregon. Book a free personal hair loss consultation at our Portland location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Oregon Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Portland, Oregon and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/oregon/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/oregon/" }],
  }),
  component: () => <StateLocationsHub stateName="Oregon" cities={cities} />,
});